import session from "@/services/SessionService";
import config from "@/config";
import { AxiosPromise } from "axios";
import { Sample } from "@/models/Sample";
import { SearchPagination, SearchFilters } from "./SearchService";
/**
 * Type for all available user filters
 */
export type DocumentSearch = {
  pagination: SearchPagination;
  filters: SearchFilters;
};
/**
 * Response type for document data
 */
type DocumentGetResponse =
  | { samples: Sample[]; pagination: SearchPagination }
  | undefined;

type DocumentFindResponse = Sample | undefined;

type DocumentPresignedUrlResponse = {
  url: string;
};

/**
 * Singleton class for fetching document data from the API
 */
class DocumentService {
  private endpoint: string = config.hostname + "/samples/";
  /**
   * Fetch all documents matching the filters provided
   *
   * @param {DocumentFilters} filters
   *
   */

  /**
   * Fetch an user by ID
   *
   * @param id The ID of the document to fetch
   *
   */
  find(id: number): AxiosPromise<DocumentFindResponse> {
    let promise: AxiosPromise<DocumentFindResponse>;
    promise = session.requestWithAuth("get", this.endpoint + String(id));
    return promise;
  }

  /**
   * Generates a presigned URL for S3 objects
   * @param id The ID of the document url to fetch
   */
  presignedUrl(id: number): AxiosPromise<DocumentPresignedUrlResponse> {
    let promise: AxiosPromise<DocumentPresignedUrlResponse>;
    promise = session.requestWithAuth(
      "get",
      this.endpoint + String(id) + "/presigned_url"
    );
    return promise;
  }

  /**
   * Fetch all users matching the filters provided
   *
   * @param {UserSearch} filters
   *
   */
  get(params: DocumentSearch): AxiosPromise<DocumentGetResponse> {
    let promise: AxiosPromise<DocumentGetResponse>;
    promise = session.requestWithAuth("get", this.endpoint, params);
    return promise;
  }
}

let documentService = new DocumentService();

export default documentService;
